import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { fuzzySearch } from '@philips-internal/oswald-ui-utils';
import { applicationModuleRegistry, foundationContext, isApplicationModuleGroup } from '../../index.js';
function getAvailableModules() {
    const availableModules = [];
    const availableGroups = [];
    const profileModules = (foundationContext.getAvailableModules() || []).map((module) => module.id);
    const modules = getRegisteredModules();
    for (const module of modules) {
        if (isApplicationModuleGroup(module)) {
            const group = module;
            const prettyGroup = getPrettyGroup(group, profileModules);
            if (prettyGroup) {
                availableModules.push(prettyGroup);
                availableGroups.push(prettyGroup);
            }
        }
        else if (profileModules.includes(module.id)) {
            if (module.hidden) {
                continue;
            }
            const prettyModule = {
                ...module,
                prettyName: MessageService.translate(module.name),
            };
            availableModules.push(prettyModule);
        }
    }
    availableModules.sort((moduleA, moduleB) => {
        const { order: orderA, prettyName: prettyNameA } = moduleA;
        const { order: orderB, prettyName: prettyNameB } = moduleB;
        const hasOrderA = typeof orderA === 'number';
        const hasOrderB = typeof orderB === 'number';
        if (hasOrderA && !hasOrderB) {
            return -1;
        }
        if (hasOrderB && !hasOrderA) {
            return 1;
        }
        if (orderA && orderB && orderA !== orderB) {
            return orderA - orderB;
        }
        return prettyNameA.localeCompare(prettyNameB);
    });
    return {
        availableGroups,
        availableModules,
    };
}
function flattenAllModules(modules) {
    return modules.flatMap((item) => {
        return isApplicationModuleGroup(item) ? flattenAllModules(item.modules) : item;
    });
}
function getPrettyGroup(group, profileModules) {
    const groupModules = [];
    for (const module of group.modules) {
        if (!profileModules.includes(module.id)) {
            continue;
        }
        const prettyModule = {
            ...module,
            prettyName: MessageService.translate(module.name),
        };
        groupModules.push(prettyModule);
    }
    if (!groupModules.length) {
        return;
    }
    return {
        ...group,
        modules: groupModules,
        prettyName: MessageService.translate(group.name),
    };
}
function getRegisteredModules() {
    const orphanModules = applicationModuleRegistry.getOrphanModules();
    const groupModules = applicationModuleRegistry.getGroups();
    return [...orphanModules, ...groupModules];
}
function searchInModules(searchTerm, { availableModules, availableGroups }) {
    const searchKeys = ['prettyName'];
    const searchOptions = {
        threshold: 0.2,
    };
    const foundModules = fuzzySearch(availableModules, searchKeys, searchTerm, searchOptions)
        .map((result) => result.item);
    for (const group of availableGroups) {
        const foundModulesOfGroup = fuzzySearch(group.modules, searchKeys, searchTerm, searchOptions)
            .map((result) => result.item);
        if (foundModulesOfGroup.length > 0) {
            const searchedGroup = {
                ...group,
                modules: foundModulesOfGroup,
            };
            foundModules.push(searchedGroup);
        }
    }
    foundModules.sort((firstModule, secondModule) => firstModule.prettyName.localeCompare(secondModule.prettyName));
    return foundModules;
}
export { flattenAllModules, getAvailableModules, getPrettyGroup, getRegisteredModules, searchInModules, };
//# sourceMappingURL=module-selector-utils.js.map